import { useEffect, useRef } from "react";
import { clamp } from "lodash";
import classNames from "classnames";
import styles from "./LoaderBar.module.scss";

type LoaderBarProps = {
  progress: number;
  total: number;
};
export function LoaderBar({ progress, total }: LoaderBarProps) {
  const percentage = clamp(total === 0 ? 0 : (progress / total) * 100, 0, 100);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.setProperty(
        "--loader-width",
        `${percentage}%`
      );
    }
  }, [percentage]);

  return (
    <div ref={containerRef} className={styles.loaderContainer}>
      <div
        className={classNames(styles.loaderContent, {
          [styles.complete]: percentage === 100,
        })}
      />
    </div>
  );
}
